<template>
  <div class="dialog-wrap">
    <el-dialog
      title="缺额信息详情"
      :close-on-click-modal="false"
      :visible.sync="dialogVisible"
      @close="handleClose"
      width="731px"
    >
      <div class="modular">
        <div class="title">调剂信息</div>
        <div class="item">
          <div class="label">院校省市：</div>
          <div class="value">{{ result.province_name }}</div>
        </div>
        <div class="item">
          <div class="label">调剂专业：</div>
          <div class="value">（{{ result.major_code }}）{{ result.major_name }}</div>

        </div>
        <div class="item">
          <div class="label">招生院校：</div>
          <div class="value">{{ result.college_name }}</div>

        </div>
        <div class="item">
          <div class="label">研究方向：</div>
          <div class="value">{{ result.direction_code?`（${result.direction_code}）`:'' }}{{ result.direction_name }}</div>

        </div>
        <div class="item">
          <div class="label">招生院系：</div>
          <div class="value">{{ result.academy_name }}</div>

        </div>
        <div class="item">
          <div class="label">计划余额：</div>
          <div class="value">{{ result.plan_last_count }}</div>

        </div>
      </div>
      <div class="modular">
        <div class="title">调剂要求</div>
        <div class="item">
          <div class="value">{{ result.adjust_demand?result.adjust_demand:'暂无' }}</div>
        </div>
      </div>
      <div
        class="modular"
        v-if="result.college_major_adjust_source"
      >
        <div class="title">调剂来源</div>
        <div class="item">
          <SourceTable :data="result.college_major_adjust_source"></SourceTable>
        </div>
      </div>
      <div
        class="modular"
        v-if="result.college_major_adjust_target"
      >
        <div class="title">调剂去向</div>
        <div class="item">
          <TargetTable :data="result.college_major_adjust_target"></TargetTable>
        </div>
      </div>
      <div
        class="modular"
        v-if="result.arr_college_score_line&&result.arr_college_score_line.length"
      >
        <div class="title">历年分数</div>
        <div class="item">
          <ScoreLineTable :data="result.arr_college_score_line"></ScoreLineTable>
        </div>
      </div>
      <div class="modular">
        <div class="title">考试科目</div>
        <div
          class="vfor"
          v-for="(item,index) in subjects"
          :key="index"
        >
          <div class="item">
            <div class="label">政治：</div>
            <div class="value">{{ item[0] ||''}}</div>
          </div>
          <div class="item">
            <div class="label">外语：</div>
            <div class="value">{{ item[1]||'' }}</div>
          </div>
          <div class="item">
            <div class="label">业务课一：</div>
            <div class="value">{{ item[2]||'' }}</div>
          </div>
          <div class="item">
            <div class="label">业务课二：</div>
            <div class="value">{{ item[3] ||'' }}</div>
          </div>
        </div>
      </div>
      <div class="modular">
        <div class="title">参考书目</div>
        <div class="item">
          <div
            class="value"
            v-if="result.reference_books&&result.reference_books!='null'"
            v-html="result.reference_books"
          ></div>
          <div
            class="value"
            v-else
          >暂无</div>
        </div>
      </div>
      <div class="modular">
        <div class="title">联系方式</div>
        <div class="item">
          <div class="label">电话：</div>
          <div class="value">{{ result.contact_phone }}</div>
        </div>
        <div class="item">
          <div class="label">邮箱：</div>
          <div class="value">{{ result.contact_email }}</div>
        </div>
        <div class="item">
          <div class="label">地址：</div>
          <div class="value">{{ result.contact_address }}</div>
        </div>
        <div class="item">
          <div class="label">研招办网址：</div>
          <div class="value">{{ result.contact_enrol_website }}</div>
        </div>
      </div>

      <div
        slot="footer"
        class="footer"
      >
        <el-button @click="handleClose()">取消</el-button>
        <el-button
          type="primary"
          @click="handleClose()"
        >确定</el-button>

      </div>
    </el-dialog>
  </div>
</template>
        
  <script>
import { collegeMajorList, majorSubjectList, academyList, majorinfo } from "@/api/common";
import { bulksingleCollege, adjustAdmin, adjustAdminEdit } from "@/api/adjust";
import SourceTable from '@/components/dialog/adjust/SourceTable.vue'
import TargetTable from '@/components/dialog/adjust/TargetTable.vue'
import ScoreLineTable from '@/components/dialog/adjust/ScoreLineTable.vue'


export default {
  components: {
    SourceTable,
    TargetTable,
    ScoreLineTable
  },
  props: {
    visible: {
      type: Boolean,
      default: false
    },
    id: {
      type: Number,
      default: null
    },
  },
  data() {
    return {
      dialogVisible: this.visible,

      result: {},
      subjects: [],
    }
  },
  watch: {
    visible(val) {
      this.dialogVisible = val
      if (val) {
        this.fetchDetail()
      }
    },
  },
  created() {
  },
  methods: {
    fetchDetail() {
      adjustAdmin({ id: this.id }).then((res) => {
        this.result = res
        this.subjects = JSON.parse(res.subjects)

      })
    },

    handleClose() {
      this.$emit('close')
    },


  }
}
   </script>
  <style lang="less" scoped>
.modular {
  border: solid;
  border-radius: 0px 0px 0px 0px;
  opacity: 1;
  border: 1px dashed #dcdfe6;
  padding: 24px;
  margin-bottom: 24px;
  .title {
    font-size: 16px;
    font-family: PingFang SC-Semibold, PingFang SC;
    font-weight: 600;
    color: #303133;
  }
  .vfor {
    margin-bottom: 24px;
  }
  .item {
    display: flex;
    align-items: center;
    margin-top: 16px;
    .label {
      font-size: 14px;
      font-family: PingFang SC-Regular, PingFang SC;
      font-weight: 400;
      color: #303133;
    }
    .value {
      font-size: 14px;
      font-family: PingFang SC-Regular, PingFang SC;
      font-weight: 400;
      color: #303133;
      line-height: 24px;
    }
  }
}
</style>
        